import React,{useState,useEffect,useRef} from "react";

import Loading from "../../../Loading/Loading"; 

import loadable from '@loadable/component';


import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import ContentFolderCard from "../../CreateContent/ContentFolderCard";
import AppTopMenuCard from "../Cards/AppTopMenuCard";
import AppElementsMenuCard from "../Cards/AppElementMenuCard";
import ListUI from "./ListUI";
import ListUISettings from "./ListUISettings";

let lazyLoad =   <Loading/>;
  
  
    
  
 const DesignElements = ({})=>{
    
               const [activeCardSettings, setActiveCardSettings] =useState(false);   
            
             const [colorTheme, setColorTheme] =useState(true);   
             const [textTheme, setTextTheme] =useState(false);   
             const [buttonTheme, setButtonTheme] =useState(false);   
             const [inputTheme, setInputTheme] =useState(false);   
             const [headerTheme, setHeaderTheme] =useState(false);  
             const [footerTheme ,  setFooterTheme ] =useState(false);  
            
             const [appTopMenuBarCard, setAppTopMenuBarCard] =useState(true);   
             const [colorThemeGrid, setColorThemeGrid] =useState(true);   
             const [A1, setA1] =useState(true);   
             const [A2, setA2] =useState(false);   
             const [A3, setA3] =useState(false);   
             const [A4, setA4] =useState(false);   
             const [A5, setA5] =useState(false);   
             const [A6, setA6] =useState(false);   
             const [A7, setA7] =useState(false);   
             const [A8, setA8] =useState(false);   
             const [A9, setA9] =useState(false);   
             const [A10, setA10] =useState(false);   
             const [A11, setA11] =useState(false);   
             const [A12, setA12] =useState(false);   
              const dispatch = useDispatch();
                   const [scrollItems, setScrollItems] = useState(false);// dark /faint
                    const [columnsList, setColumnsList] = useState(3);// black / white
                    const [fontFamily, setFontFamily] = useState("'Poppins', 'Helvetica Neue', sans-serif");// black / white
                   const [fontWeight, setFontWeight] = useState("700");// black / white
                  const [iWidth, setiWidth] = useState("90%");
                    const [iHeight, setiHeight] = useState(80);
                    const [textFontSize, setTextFontSize] = useState(10);
                    
                   const [borderRadius, setBorderRadius] = useState(100);
                   const [marginLeft, setmarginLeft] = useState(10);
                  const [marginTop, setmarginTop] = useState(50);
                   const [imarginLeft, setimarginLeft] = useState(18);
                  const [imarginTop, setimarginTop] = useState(5);
                  const [aspectRatio, setiAspectRatio] = useState(4/3);
                   const [showText, setShowText] = useState(true);
                   const [textAlignment, setTextAlignment] = useState("center");
                 const [reloadList, setReloadList] = useState(true);
                  
                   
                 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
                     {
                       
                       dispatch({type: "CURSOR",payload:true  });
                   
                       dispatch({type: "CURSORTEXT",payload:CursorText})
                       dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
                       dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
                     }
                      
                     const handleMouseLeave = () => {
                       
                       dispatch({type: "CURSOR",payload:false})
                   
                       dispatch({type: "CURSORTEXT",payload:""})
                   
                       dispatch({type: "CURSORTEXTBG",payload:""})
                       dispatch({type: "CURSORTEXTCOLOR",payload:""})
                     
                   
                   }

                       const colorPickerOptionArray =[     
                               'rgba(255, 114, 94, 1)',      
                           'rgba(255, 114, 94, 0.5)', 
                                
                         'rgba(255, 255, 255, 0.9)',    
                           'rgba(255, 114, 94, 0.1)'      
                           , 'rgba(55, 71, 79, 1)',       
                           'rgba(255, 193, 0, 1)'  ];
                   
                   
                           const [activeColorPickerValue,setActiveColorPickerValue]=useState('#99cc99')
                           const [themeColor ,setThemeColor] =useState({
                             primaryColor:'rgba(255, 204, 153,1)',
                              primaryColorOpacity5:'rgba(255, 204, 153,0.5)', 
                             buttonColor:'rgba(255, 204, 153,0.9)',
                             iconColorInfo:'rgba(83, 89, 103,0.9)', 
                              activityColor:'rgba(255, 204, 153,0.1)'});
                   
 useEffect(() => {
        
 },[])
                   return (<>

<div className="appElementScroller" style={{padding:"5px"}}>
  <AppElementsMenuCard  activeCard={A1}  icon={1} title ="Basic Items" onClickPopup={
      ()=>{setA1(true);;setA2(false);setA3(false);;setA4(false);setA5(false)  ;setA6(false) ;setA7(false);
        ;setA8(false);;setA9(false);;setA10(false);;setA11(false);;setA12(false);
        }} />
  <AppElementsMenuCard  activeCard={A2}  icon={2} title ="Buttons" onClickPopup={
      ()=>{ setA1(false);;setA2(true);setA3(false);;setA4(false);setA5(false)  ;setA6(false) ;setA7(false);
        ;setA8(false);;setA9(false);;setA10(false);;setA11(false);;setA12(false);
      }} />
  <AppElementsMenuCard  activeCard={A3}  icon={3} title ="Lists" onClickPopup={
      ()=>{setA1(false);;setA2(false);setA3(true);;setA4(false);setA5(false)  ;setA6(false) ;setA7(false); 
        ;setA8(false);;setA9(false);;setA10(false);;setA11(false);;setA12(false);
      }} />
  <AppElementsMenuCard  activeCard={A4}  icon={4} title ="Banners" onClickPopup={
      ()=>{setA1(false);;setA2(false);setA3(false);;setA4(true);setA5(false)  ;setA6(false) ;setA7(false); 
        ;setA8(false);;setA9(false);;setA10(false);;setA11(false);;setA12(false);
      }} />
  <AppElementsMenuCard  activeCard={A5}  icon={5} title ="Store" onClickPopup={
      ()=>{setA1(false);;setA2(false);setA3(false);;setA4(false);setA5(true)  ;setA6(false) ;setA7(false); 
        ;setA8(false);;setA9(false);;setA10(false);;setA11(false);;setA12(false);
      }} />
  <AppElementsMenuCard  activeCard={A6}  icon={6} title ="Pricing Plans" onClickPopup={
      ()=>{setA1(false);;setA2(false);setA3(false);;setA4(false);setA5(false)  ;setA6(true) ;setA7(false); 
        ;setA8(false);;setA9(false);;setA10(false);;setA11(false);;setA12(false);
      }} />
  <AppElementsMenuCard  activeCard={A7}  icon={7} title ="Events" onClickPopup={
      ()=>{ setA1(false);;setA2(false);setA3(false);;setA4(false);setA5(false)  ;setA6(false) ;setA7(true);
        ;setA8(false);;setA9(false);;setA10(false);;setA11(false);;setA12(false);
      }} />
   <AppElementsMenuCard  activeCard={A8}  icon={8} title ="Products" onClickPopup={
      ()=>{  setA1(false);;setA2(false);setA3(false);;setA4(false);setA5(false)  ;setA6(false) ;setA7(false);
        ;setA8(true);;setA9(false);;setA10(false);;setA11(false);;setA12(false);
      }} />
  <AppElementsMenuCard  activeCard={A9}  icon={9} title ="Blogs" onClickPopup={
      ()=>{ setA1(false);;setA2(false);setA3(false);;setA4(false);setA5(false)  ;setA6(false) ;setA7(false);
        ;setA8(false);;setA9(true);;setA10(false);;setA11(false);;setA12(false);
    }} />
  <AppElementsMenuCard  activeCard={A10}  icon={10} title ="Groups" onClickPopup={
      ()=>{ setA1(false);;setA2(false);setA3(false);;setA4(false);setA5(false)  ;setA6(false) ;setA7(false);
        ;setA8(false);;setA9(false);;setA10(true);;setA11(false);;setA12(false);
    }} />
  <AppElementsMenuCard  activeCard={A11}  icon={11} title ="Social Buttons" onClickPopup={
      ()=>{setA1(false);;setA2(false);setA3(false);;setA4(false);setA5(false)  ;setA6(false) ;setA7(false);
        ;setA8(false);;setA9(false);;setA10(false);;setA11(true);;setA12(false);
     }} />
  <AppElementsMenuCard  activeCard={A12}  icon={12} title ="FAQs" onClickPopup={
      ()=>{ setA1(false);;setA2(false);setA3(false);;setA4(false);setA5(false)  ;setA6(false) ;setA7(false);
        ;setA8(false);;setA9(false);;setA10(false);;setA11(false);;setA12(true);
    }} />
     
</div> 
 </>
) 

}
export default DesignElements;